import { render, staticRenderFns } from "./label-order-state.vue?vue&type=template&id=6578c30e&"
import script from "./label-order-state.vue.ts?vue&type=script&lang=ts&"
export * from "./label-order-state.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports